import { usersClient, UserAchievementTier } from "../generated/users";
export var mockUserClient = function() {
    usersClient.usersService.followUser = function() {
        return Promise.resolve({});
    };
    usersClient.usersService.unfollowUser = function() {
        return Promise.resolve({});
    };
    usersClient.profileService.getProfilePreview = function() {
        return Promise.resolve({
            userName: "Bojan",
            displayName: "Bojan Tunguz",
            profileUrl: "/tunguz",
            thumbnailUrl: "https://storage.googleapis.com/kaggle-avatars/images/417337-fb.jpg",
            performanceTier: UserAchievementTier.GRANDMASTER,
            country: "United States",
            region: "Indiana",
            city: "Greencastle",
            occupation: "Data Scientist at Nvidia (Rapids.ai)",
            isFollowing: true
        });
    };
    usersClient.usersService.getUser = function() {
        return Promise.resolve({
            displayName: "Bojan",
            userName: "Bojan",
            thumbnailUrl: "https://storage.googleapis.com/kaggle-avatars/thumbnails/1984321-kg.jpg",
            profileUrl: "/tunguz",
            registerDate: new Date(),
            lastVisitDate: new Date(),
            statusId: 0,
            performanceTier: UserAchievementTier.NOVICE,
            userRoles: [],
            userLogins: [],
            groupIds: [],
            duplicateUsers: [],
            hasPhoneVerifications: false,
            failedNerdchas: 0,
            hasPendingNerdcha: false,
            deleteRequests: [],
            isAdmin: false,
            isKaggleBot: false,
            isAnonymous: false,
            canAct: false,
            canBeSeen: false,
            isPhoneVerified: false
        });
    };
};
